import "./Loader.css";

import React from "react";
import truck from "../images/truck.gif";

const LoaderComponent = ({ userDetail }) => {
  console.log("userDetail", userDetail);
  return (
    <div className="loader">
      <div class="load"></div>

      {/* {Object.keys(userDetail).length > 0 ? (
        <div class="load"></div>
      ) : (
        <img src={truck} alt="Loading Truck" />
      )} */}
    </div>
  );
};

export default LoaderComponent;
